import _replaceAllInstanceProperty from "@babel/runtime-corejs3/core-js/instance/replace-all";
import { useApplicationFieldVisibility } from "@Client/@Composables/application-standalone/useApplicationFieldVisibility";
import { useFillOutVisibility } from "@Client/@Composables/application-standalone/useFillOutVisibility";
import { APPLICATION_STEPS } from "@Client/@Utils/enums";
import { APPLICATION_PATH } from "@Client/@Utils/enums/application-paths";
import { computed } from "@vue/composition-api";
export const useApplicantFieldVisibility = options => {
  const {
    computeSchemaVisibility,
    computeTogglerVisibility
  } = useApplicationFieldVisibility();
  const {
    computeFillOutVisibility
  } = useFillOutVisibility();
  const applicantIndex = computed(() => {
    return options.applicantIndex.value;
  });
  const currentApplicantPath = computed(() => {
    return applicantIndex.value === 0 ? APPLICATION_PATH.MAIN_APPLICANT : `${APPLICATION_PATH.CO_APPLICANTS}[${applicantIndex.value - 1}]`;
  });
  const isApplicantVisibleFromFillOut = computed(() => {
    var _options$applicantId;
    return computeFillOutVisibility(APPLICATION_STEPS.APPLICANTS, {
      applicantId: (_options$applicantId = options.applicantId) == null ? void 0 : _options$applicantId.value
    }).value;
  });
  const currentApplicantVisibilityPath = computed(() => {
    var _context;
    return _replaceAllInstanceProperty(_context = currentApplicantPath.value).call(_context, /\[[[0-9]+\]/g, "");
  });
  const applicantSalutationVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(currentApplicantVisibilityPath.value + "[personal-details][salutation]");
    return visibleFromSchema.value && isApplicantVisibleFromFillOut.value;
  });
  const applicantFirstNameVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(currentApplicantVisibilityPath.value + "[personal-details][first-name]");
    return visibleFromSchema.value && isApplicantVisibleFromFillOut.value;
  });
  const applicantMiddleNameVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(currentApplicantVisibilityPath.value + "[personal-details][middle-name]");
    return visibleFromSchema.value && isApplicantVisibleFromFillOut.value;
  });
  const applicantLastNameVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(currentApplicantVisibilityPath.value + "[personal-details][last-name]");
    return visibleFromSchema.value && isApplicantVisibleFromFillOut.value;
  });
  const applicantEmailVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(currentApplicantVisibilityPath.value + "[personal-details][email]");
    return visibleFromSchema.value && isApplicantVisibleFromFillOut.value;
  });
  const applicantPhoneNumberVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(currentApplicantVisibilityPath.value + "[personal-details][phone-number]");
    return visibleFromSchema.value && isApplicantVisibleFromFillOut.value;
  });
  const applicantWorkPhoneVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(currentApplicantVisibilityPath.value + "[personal-details][work-phone]");
    return visibleFromSchema.value && isApplicantVisibleFromFillOut.value;
  });
  const applicantAltPhoneNumberVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(currentApplicantVisibilityPath.value + "[personal-details][alt-phone-number]");
    return visibleFromSchema.value && isApplicantVisibleFromFillOut.value;
  });
  const applicantFirstTimeHomeBuyerVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(currentApplicantVisibilityPath.value + "[personal-details][first-time-home-buyer]");
    return visibleFromSchema.value && isApplicantVisibleFromFillOut.value;
  });
  const applicantMaritalStatusVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(currentApplicantVisibilityPath.value + "[personal-details][marital-status]");
    return visibleFromSchema.value && isApplicantVisibleFromFillOut.value;
  });
  const applicantDateOfBirthVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(currentApplicantVisibilityPath.value + "[personal-details][date-of-birth]");
    return visibleFromSchema.value && isApplicantVisibleFromFillOut.value;
  });
  const applicantNumChildrenVisible = computed(() => {
    if (currentApplicantPath.value.replace(/[[\]']+/g, "") !== APPLICATION_PATH.MAIN_APPLICANT.replace(/[[\]']+/g, "")) return false;
    const visibleFromSchema = computeSchemaVisibility(currentApplicantVisibilityPath.value + "[personal-details][num-children]");
    return visibleFromSchema.value && isApplicantVisibleFromFillOut.value;
  });
  const applicantLanguagePreferenceVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(currentApplicantVisibilityPath.value + "[personal-details][language-preference]");
    return visibleFromSchema.value && isApplicantVisibleFromFillOut.value;
  });
  const applicantOwnVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(currentApplicantVisibilityPath.value + "[personal-details][own]");
    return visibleFromSchema.value && isApplicantVisibleFromFillOut.value;
  });
  const applicantMonthlyRentVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(currentApplicantVisibilityPath.value + "[personal-details][monthly-rent]");
    const visibleFromToggler = computeTogglerVisibility(currentApplicantPath.value + "[personal-details][monthly-rent]", [currentApplicantPath.value + "[personal-details][own]"]);
    return visibleFromSchema.value && visibleFromToggler.value;
  });
  const coApplicantTypeVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(currentApplicantVisibilityPath.value + "[personal-details][co-applicant-type]");
    return visibleFromSchema.value && isApplicantVisibleFromFillOut.value;
  });
  const applicantRelationshipToMainApplicantVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(currentApplicantVisibilityPath.value + "[personal-details][relationship-to-main-applicant]");
    return visibleFromSchema.value && isApplicantVisibleFromFillOut.value;
  });
  const applicantAddressesVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(currentApplicantVisibilityPath.value + "[personal-details][addresses]");
    return visibleFromSchema.value && isApplicantVisibleFromFillOut.value;
  });
  const applicantSinVisible = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(currentApplicantVisibilityPath.value + "[personal-details][sin]");
    return visibleFromSchema.value && isApplicantVisibleFromFillOut.value;
  });
  return {
    applicantSalutationVisible,
    applicantFirstNameVisible,
    applicantMiddleNameVisible,
    applicantLastNameVisible,
    applicantEmailVisible,
    applicantPhoneNumberVisible,
    applicantWorkPhoneVisible,
    applicantAltPhoneNumberVisible,
    applicantFirstTimeHomeBuyerVisible,
    applicantMaritalStatusVisible,
    applicantDateOfBirthVisible,
    applicantNumChildrenVisible,
    applicantLanguagePreferenceVisible,
    applicantOwnVisible,
    applicantMonthlyRentVisible,
    coApplicantTypeVisible,
    applicantRelationshipToMainApplicantVisible,
    applicantAddressesVisible,
    applicantSinVisible,
    isApplicantVisibleFromFillOut
  };
};